import TablePagination from './table-pagination';

export type { TablePaginationProps } from './table-pagination';

export default TablePagination;
